export default __webpack_public_path__ + "static/media/burger-menu-btn2.05f69d4c.PNG";